/* eslint-disable react/react-in-jsx-scope */
import * as React from 'react';
import { useState, useEffect, useMemo, useCallback } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router'
import { useUserContext, useUserDispatch } from '../../contexts/UserContext';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
    DataGrid,
    gridClasses,
    GridColDef,
    GridToolbarQuickFilter,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    useGridSelector,
  } from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import { Avatar, Box, Divider, IconButton, InputBase, Paper, useTheme, Select, 
    MenuItem, Typography, } from '@mui/material'
import ProductsActions from '../../components/dataTable/ProductsActions';
import { Link } from "react-router";

export default function Stock() {
    const navigate = useNavigate();
    const user = useUserContext();
    // const dispatch = useUserDispatch();
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);
    const [productId, setproductId] = useState(null);
    const [ filterData, setFilterData] = useState();
    const [rowId, setRowId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [totalRow, settotalRow] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
      });

    const [rowCount ,setRowCount] = useState({
        rowCount: totalRow,
    })

    
    const apiurl = `${process.env.REACT_APP_API}`
    const imgurl = `${process.env.REACT_APP_URL}`
    const webpath = '/products'
  
    const columns= useMemo(() => [
        { field: "id", type: "number", headerName: "ID", headerAlign: 'center', width: 60, },
        {
          field: "img",
          headerName: "Image",
          renderCell:params=><Avatar variant="rounded" src={`${imgurl}/image/products/${params.row.img}`} />,
          sortable: false,
          filterable: false,
          headerAlign: 'center',
          width: 64,
          editable: false,
      
          // renderCell: (params) => {
          //   return <img src={`${process.env.REACT_APP_URL}/image/users/${params.row.Avatar} || '/user.png'`} alt="" />;
          // },
        },
        {
          field: "name",
          type: "string",
          headerName: "Name",
          width: 150,
          editable: false,
          flex: 1,
        },
        // {
        //   field: "lastName",
        //   type: "string",
        //   headerName: "Last name",
        //   width: 150,
        // },
        // {
        //   field: "description",
        //   type: "string",
        //   headerName: "Description",
        //   width: 200,
        //   editable: true,
        // },
        {
          field: "category",
          // type: "boolean",
          headerName: "Category",
          width: 100,
          headerAlign: 'center',
          type: 'singleSelect',
          // valueOptions: roleOptions,
          valueOptions: ['Bakery','Chiffon', 'Cake', ],
            // valueGetter: ({ value, colDef }) => {
            //   console.log(value,colDef);
            //   const option = colDef.valueOptions.find(
            //     ({ value: optionValue }) => value === optionValue
            //   );
            //   return option.label;
            // },
          editable: false,
          flex: 0.3,
      
        },
        {
          field: "price",
          type: "number",
          headerName: "Price",
          // valueOptions: ['false', 'true'],
          // valueGetter: (value) => {
          //   return value==1? true:false;
          // },
          width: 100,
          editable: false,
        },
        {
          field: "instock",
          type: "number",
          headerName: "InStock",
          // valueGetter: (value) => {
          //   return value==1? true:false;
          // },
          width: 100,
          editable:false,
        },
        // {
        //     field: 'actions',
        //     headerName: 'Actions',
        //     type: 'actions',
        //     renderCell: params => <ProductsActions {...{params, rowId, setRowId, webpath}} />,
        //     // headerClassName: 'datatable-header',
        //     headerAlign: 'center',
        //     width: 150,
        //     editable: false,
        //     // flex: 1,
        // },
        // {
        //     field: 'total',
        //     headerName: 'Total',
        //     description: 'This column has a value getter and is not sortable.',
        //     sortable: false,
        //     width: 160,
        //     valueGetter: (value, row) => `${row.qty * row.price }`,
        // },
    ],[rowId]);

    const columnsDetail: GridColDef[] = [
        {
            field: 'id',
            headerName: 'ID',
            width: 60,
            editable: false,
        },
        {
            field: 'date',
            headerName: 'Date',
            width: 150,
            editable: false,
            flex: 1,
        },
        {
            field: 'transType',
            headerName: 'Type',
            width: 90,
            editable: false,
            flex: 0.3,
        },
        {
            field: 'cuser',
            headerName: 'UserID',
            width: 80,
            editable: false,
        },
        {
            field: 'uname',
            headerName: 'User',
            width: 100,
            editable: false,
            flex: 1,
        },
        {
            field: 'prodId',
            headerName: 'ProdID',
            width: 60,
            editable: false,
        },
        {
            field: 'prodName',
            headerName: 'ProdName',
            width: 150,
            editable: false,
            flex: 1,
        },
        {
            field: 'qty',
            headerName: 'Qty',
            type: 'number',
            width: 60,
            editable: true,
            flex: 0.5,
        },
        { field: 'InvNo', 
            headerName: 'InvNo', 
            width: 60, 
            hide: false,
            flex: 0.5,
        },
    ];

    //list invoice
    const fetchStock = async () => {
        setLoading(true);
        try {
          const result = await axios.get(`${apiurl}/products.php?mode=list`);
          
        //   console.log(result);
          // console.log(result.data);
          // if(result.data.length>0) {
          if(result.data && result.data[0].length>0) {  
            // const data = await response.json();
            // console.log(result.data[0]);
            setData(result.data[0]);
            setLoading(false);
            return result.data[0];
          } else {
            console.log(result);
            setLoading(false);
          }
  
        }
        catch(err) {
            console.log(err);
            setLoading(false);
        }
    }

        //list invoice
        const fetchStockTrans = async (pdid) => {
            setLoading2(true);
            // console.log(pdid);

            try {
              const result = await axios.get(`${apiurl}/products.php?mode=gettrans&id=${pdid}`, {
                params: {
                  itemsPerPage: paginationModel.pageSize,
                  page: paginationModel.page,
                },
              });
              
            //   console.log(result);
              // console.log(result.data);
              // if(result.data.length>0) {
              if(result.data && result.data[0].length>0) {  
                // const data = await response.json();
                // console.log(result.data[0]);
                setDetail(result.data[0]);
                settotalRow(result.data.rowTotal);
                setLoading2(false);
                return result.data[0];
              } else {
                console.log(result);
                setDetail([]);
                setLoading2(false);
              }
      
            }
            catch(err) {
                console.log(err);
                setDetail([]);
                setLoading2(false);
            }
        }
  
    useEffect(() => {
      if(user?.user?.isAdmin < 1 ) {  // Role !== 'Admin'
        navigate("/")
      }}) 
      
    useEffect(() => {
  
        fetchStock();
      
    },[])

    useEffect(() => {
        // console.log(productId);
        fetchStockTrans(productId);
      },[paginationModel])


    const handleCellClick = (e) => {
        // console.log(e.id);
        setproductId(e.id);
        setPaginationModel({
            page: 0,
            pageSize: 100,
          });
        // fetchStockTrans(e.id);
    }

    function Pagination({ page, onPageChange, className }) {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
            />
        );
    }

    function CustomPagination(props) {
        return <GridPagination ActionsComponent={Pagination} {...props} />;
    }

    // console.log(data);

  return (
    <div className="flex flex-col xl:flex-row w-svw sm:w-[calc(100vw-160px)]  h-[calc(100vh-120px)] overflow-y-auto p-4 gap-y-4">

        {/* <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>InvNo</TableCell>
                        <TableCell align="center">Date</TableCell>
                        <TableCell align="center">Cashier</TableCell>
                        <TableCell align="center">Customer</TableCell>
                        <TableCell align="center">PaidType</TableCell>
                        <TableCell align="right">Amount&nbsp;($)</TableCell>
                        <TableCell align="right">Discount&nbsp;($)</TableCell>
                        <TableCell align="right">Vat&nbsp;($)</TableCell>
                        <TableCell align="right">Total&nbsp;($)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data?.map((row) => (
                    <Row key={row.InvNo} row={row} />
                ))}
                </TableBody>
            </Table>
        </TableContainer> */}
        <div className="w-full xl:w-1/2 h-96 xl:h-[calc(100vh-170px)] ">
            <span>Stock Card</span>
            <Link to="/products/stocktrans" 
                className="inline-block  ml-3 p-1 px-1 text-green-400 bg-slate-500 rounded hover:bg-teal-500">Add Stock.</Link>
            {data && 
            <DataGrid 
                checkboxSelection={false} 
                rows={data} 
                // rowCount={rowCountState}
                columns={columns} 
                density='compact'
                initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                    }}
                // page={page}
                // autoPageSize
                // pageSize={pageSize}
                // rowsPerPageOptions={[5,10,30,50,100]}
                // pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
                // pagination
                // paginationMode="client"
                // onPageChange={(newPage) => setPage(newPage)}
                // onPageChange={handlePageChange}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                // onPageSizeChange={handlePageSizeChange}
                // filterMode="server"
                // onFilterModelChange={onFilterChange}
                // disableSelectionOnClick
                getRowId={(row) => row.id}
                // onCellEditCommit={(params) => setRowId(params.id)}
                // processRowUpdate={(updatedRow, originalRow) => {
                // console.log(updatedRow);
                // console.log(originalRow);
                // getObjectChanges(originalRow, updatedRow)
                // return updatedRow;
                // setRowId(params.id)
                // }}
                onCellClick={handleCellClick}
                headerHeight={38}
                slots={{ toolbar:  GridToolbarQuickFilter 
                            // GridToolbarFilterButton,
                        
                }}
                // components={{
                //         Toolbar: CustomToolbar,
                //         // Pagination: CustomPagination,
                //     // BaseCheckbox: CustomCheck,
                // }}
                // componentsProps={{
                //   toolbar: {
                //     showQuickFilter: true,
                //     quickFilterProps: { debounceMs: 1000},
                //   },
                // }}
                sx={{ 
                    // m:2,
                    [`& .${gridClasses.row}`]: {
                        bgcolor: '#f1e9e9',
                        // bgcolor: (theme) =>
                        // theme.palette.mode === 'light' ? grey[300] : grey[900],
                    },
                    [`& .${gridClasses.columnHeader}`] : {
                        bgcolor: '#0e0e7b',
                        color: '#ffffff',
                        // bgcolor: (theme) =>
                        //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                    },
                    [`& .${gridClasses.footerContainer}`] : {
                        bgcolor: '#0a55b1',
                        color: '#ffffff',
                    },
                    "& .MuiDataGrid-row:hover": {
                        backgroundColor: "skyblue"
                        // color: "red"
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                        bgcolor: '#0e6496',
                        color: '#ffffff',
                        '&:hover': {
                            bgcolor: '#1593c4',
                        },
                    },
                    "& .MuiSvgIcon-root": {
                        fill: "#9e9a9a",
                    },
                    "& .MuiInputBase-input.MuiInput-input": {
                        color: "#9e9a9a",
                    },
                    "& .MuiTablePagination-root": {
                        color: "#ffffff",
                    },
                    [`.${gridClasses.cell}.neg`]: {
                        backgroundColor: '#b9d5ff91',
                        color: '#ef0b0b',
                    },
                    [`.${gridClasses.cell}.pos`]: {
                    // backgroundColor: '#ff943975',
                    color: '#000000',
                    },
                    // [`& .${gridClasses.GridToolbarExport}`] : {
                    //   color: (theme) =>
                    //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                    // },

                }}
                // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                getCellClassName={(params) => {
                    if (params.field === 'instock') {
                        return params.value < 0 ? 'neg' : 'pos';;
                    }
                }}
                loading={loading}
                // className="bg-gray-600 bg-gray-600"
            />
            }
        </div>
        <div className="w-full xl:w-1/2 h-80 xl:h-[calc(100vh-170px)] pt-4 xl:p-1 items-start">
            <span>Detail</span>
            {data && 
                <DataGrid
                    rows={detail}
                    rowCount={totalRow}
                    columns={columnsDetail}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                                cuser: false,
                                prodId: false,
                                prodName: false,
                            },
                        },
                    }}
                    density='compact'
                    paginationMode="server"
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    onRowCountChange ={setRowCount}
                    pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
                    pagination
                    slots={{
                        pagination: CustomPagination,
                    }}
                    // components={{
                    //     Toolbar: CustomToolbar,
                    // }}
                    loading={loading2}
                    getRowId={(row) => row.id}
                    sx={{ 
                        // m:2,
                        [`& .${gridClasses.row}`]: {
                            bgcolor: '#f1e9e9',
                            // bgcolor: (theme) =>
                            // theme.palette.mode === 'light' ? grey[300] : grey[900],
                        },
                        [`& .${gridClasses.columnHeader}`] : {
                            bgcolor: '#0e0e7b',
                            color: '#ffffff',
                            // bgcolor: (theme) =>
                            //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                        },
                        [`& .${gridClasses.footerContainer}`] : {
                            bgcolor: '#0a55b1',
                            color: '#ffffff',
                        },
                        "& .MuiDataGrid-row:hover": {
                            bgcolor: "skyblue"
                            // color: "red"
                        },
                        "& .MuiDataGrid-row.Mui-selected": {
                            bgcolor: '#0e6496',
                            color: '#ffffff',
                            '&:hover': {
                                bgcolor: '#1593c4',
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fill: "#9e9a9a",
                        },
                        "& .MuiInputBase-input.MuiInput-input": {
                            color: "#9e9a9a",
                        },
                        "& .MuiTablePagination-root": {
                            color: "#ffffff",
                        },
                        // [`& .${gridClasses.GridToolbarExport}`] : {
                        //   color: (theme) =>
                        //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                        // },

                    }}
                />
            }
        </div>    
    </div>
  )
}

